var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"Search Results","visible":_vm.visible},on:{"close":_vm.close}},[_c('el-table',{attrs:{"data":_vm.results,"stripe":"","height":"300"},on:{"row-click":_vm.resultSelected}},_vm._l((_vm.fields),function(item,index){return _c('el-table-column',{key:index,attrs:{"property":item,"label":item,"sortable":""}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5a0837a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/searchResultsDialog.vue
// module id = a/Kl
// module chunks = 1